import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Telegram Mini Apps Analytics — load via CDN ONLY inside real Telegram.
// Outside TG (regular browser preview), telegram-web-app.js still sets
// window.Telegram.WebApp but with platform="unknown" and empty initData,
// so we gate on those to avoid the SDK's launch-params error.
const tgaToken = process.env.REACT_APP_TGA_TOKEN;
const tgaAppName = process.env.REACT_APP_TGA_APP_NAME;
const tgWA = typeof window !== "undefined" ? window.Telegram?.WebApp : null;
const isTelegramEnv =
  !!tgWA &&
  !!tgWA.platform &&
  tgWA.platform !== "unknown" &&
  !!tgWA.initData;
if (tgaToken && tgaAppName && isTelegramEnv) {
  const s = document.createElement("script");
  s.async = true;
  s.src = "https://tganalytics.xyz/index.js";
  s.onload = () => {
    try {
      window.telegramAnalytics?.init({ token: tgaToken, appName: tgaAppName });
    } catch (e) {
      console.warn("[tg-analytics] init failed:", e);
    }
  };
  s.onerror = () => console.warn("[tg-analytics] CDN failed to load");
  document.head.appendChild(s);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
